import React from 'react';
import { Link } from 'react-router-dom';

const PoliticaPrivacidade: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
          {/* Header */}
          <div className="bg-blue-600 px-6 py-8">
            <h1 className="text-3xl font-bold text-white">Política de Privacidade</h1>
            <p className="text-blue-100 mt-2">Falcon Hub - Agendamento de cargas inteligente</p>
            <p className="text-blue-200 text-sm mt-1">Última atualização: Agosto de 2026</p>
          </div>

          {/* Content */}
          <div className="px-6 py-8 space-y-8">
            {/* Introdução */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Introdução</h2>
              <div className="prose prose-blue max-w-none text-gray-700 space-y-3">
                <p>
                  Esta Política de Privacidade descreve como o <strong>Falcon Hub - Agendamento de cargas inteligente</strong> (doravante denominado "Sistema") coleta, usa, protege e compartilha suas informações pessoais, em conformidade com a Lei Geral de Proteção de Dados (LGPD) - Lei nº 13.709/2018.
                </p>
                <p>
                  Ao utilizar nosso Sistema, você concorda com a coleta e uso de informações de acordo com esta política.
                </p>
              </div>
            </section>

            {/* Dados Coletados */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Dados Pessoais Coletados</h2>
              <div className="prose prose-blue max-w-none text-gray-700 space-y-3">
                <p>Coletamos as seguintes categorias de dados pessoais:</p>
                
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-gray-900 mb-2">2.1 Dados de Identificação</h3>
                  <ul className="list-disc list-inside space-y-1">
                    <li>Nome completo</li>
                    <li>Endereço de e-mail</li>
                    <li>Login de acesso</li>
                    <li>Telefone de contato</li>
                  </ul>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-gray-900 mb-2">2.2 Dados Profissionais</h3>
                  <ul className="list-disc list-inside space-y-1">
                    <li>CNPJ (para fornecedores)</li>
                    <li>Perfil de acesso no sistema</li>
                    <li>Filiais permitidas</li>
                    <li>Região de atuação</li>
                  </ul>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-gray-900 mb-2">2.3 Dados de Autenticação</h3>
                  <ul className="list-disc list-inside space-y-1">
                    <li>Senha (armazenada de forma criptografada com bcrypt)</li>
                    <li>Tokens de acesso (JWT com expiração de 15 minutos)</li>
                    <li>Refresh tokens (expiração de 7 dias, revogáveis)</li>
                    <li>Foto de perfil (opcional)</li>
                    <li>Senhas temporárias (hash bcrypt, expiração de 30 minutos)</li>
                  </ul>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-gray-900 mb-2">2.4 Dados de Visitas</h3>
                  <ul className="list-disc list-inside space-y-1">
                    <li>Nome do visitante</li>
                    <li>E-mail e telefone do visitante</li>
                    <li>Empresa representada</li>
                    <li>Foto do visitante (para identificação no check-in)</li>
                    <li>Assunto e documento da visita</li>
                    <li>Código de verificação da visita</li>
                    <li>Data, horário e status da visita</li>
                    <li>Observações de reagendamento e cancelamento</li>
                  </ul>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-gray-900 mb-2">2.5 Dados de Uso</h3>
                  <ul className="list-disc list-inside space-y-1">
                    <li>Endereço IP</li>
                    <li>User agent (navegador/dispositivo)</li>
                    <li>Logs de acesso e atividades</li>
                    <li>Timestamp de ações realizadas</li>
                  </ul>
                </div>
              </div>
            </section>

            {/* Finalidade */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Finalidade do Tratamento</h2>
              <div className="prose prose-blue max-w-none text-gray-700 space-y-3">
                <p>Utilizamos seus dados pessoais para as seguintes finalidades:</p>
                
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-gray-900 mb-2">3.1 Execução de Contrato</h3>
                  <ul className="list-disc list-inside space-y-1">
                    <li>Gerenciamento de solicitações de agendamento</li>
                    <li>Coordenação de entregas e recebimentos</li>
                    <li>Comunicação sobre status de solicitações</li>
                    <li>Gestão de cargas e pedidos</li>
                    <li>Agendamento e gestão de visitas às instalações</li>
                    <li>Check-in e identificação de visitantes</li>
                    <li>Notificações por email sobre status de visitas (aprovação, reagendamento, cancelamento)</li>
                  </ul>
                </div>

                <div className="bg-blue-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-gray-900 mb-2">3.2 Legítimo Interesse</h3>
                  <ul className="list-disc list-inside space-y-1">
                    <li>Autenticação e controle de acesso</li>
                    <li>Segurança do sistema e prevenção de fraudes</li>
                    <li>Melhoria contínua dos serviços</li>
                    <li>Análise de uso do sistema</li>
                  </ul>
                </div>

                <div className="bg-blue-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-gray-900 mb-2">3.3 Obrigação Legal</h3>
                  <ul className="list-disc list-inside space-y-1">
                    <li>Cumprimento de obrigações fiscais e contábeis</li>
                    <li>Atendimento a requisições de autoridades</li>
                    <li>Preservação de evidências</li>
                  </ul>
                </div>
              </div>
            </section>

            {/* Base Legal */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Base Legal</h2>
              <div className="prose prose-blue max-w-none text-gray-700 space-y-3">
                <p>O tratamento de seus dados pessoais é realizado com base nas seguintes bases legais previstas na LGPD:</p>
                
                <ul className="list-disc list-inside space-y-2">
                  <li><strong>Art. 7, inciso V - Execução de Contrato:</strong> Para fornecer os serviços de agendamento e gestão de cargas.</li>
                  <li><strong>Art. 7, inciso VII - Legítimo Interesse:</strong> Para segurança do sistema, autenticação e melhoria dos serviços.</li>
                  <li><strong>Art. 7, inciso II - Obrigação Legal:</strong> Para cumprimento de obrigações legais e regulatórias.</li>
                </ul>
              </div>
            </section>

            {/* Compartilhamento */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Compartilhamento de Dados</h2>
              <div className="prose prose-blue max-w-none text-gray-700 space-y-3">
                <p>Seus dados podem ser compartilhados nas seguintes situações:</p>
                
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-gray-900 mb-2">5.1 Com Terceiros Autorizados</h3>
                  <ul className="list-disc list-inside space-y-1">
                    <li>Filiais da empresa para coordenação logística</li>
                    <li>Parceiros de transporte (quando necessário)</li>
                    <li>Fornecedores de serviços de e-mail (Resend)</li>
                    <li>Fornecedores de infraestrutura (Supabase, Render, Firebase)</li>
                    <li>Compradores e solicitantes de visitas (dados de agendamento compartilhados entre as partes envolvidas)</li>
                  </ul>
                </div>

                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-gray-900 mb-2">5.2 Por Obrigação Legal</h3>
                  <ul className="list-disc list-inside space-y-1">
                    <li>Quando exigido por ordem judicial ou autoridade competente</li>
                    <li>Para cumprimento de obrigações legais e regulatórias</li>
                  </ul>
                </div>

                <p className="text-sm text-gray-600 mt-4">
                  <strong>Nota:</strong> Não vendemos, alugamos ou comercializamos seus dados pessoais a terceiros para fins de marketing.
                </p>
              </div>
            </section>

            {/* Retenção */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Retenção de Dados</h2>
              <div className="prose prose-blue max-w-none text-gray-700 space-y-3">
                <p>Seus dados serão retidos pelo período necessário para cumprir as finalidades descritas nesta política, conforme abaixo:</p>
                
                <div className="bg-gray-50 p-4 rounded-lg">
                  <ul className="list-disc list-inside space-y-1">
                    <li><strong>Dados de cadastro:</strong> Enquanto a conta estiver ativa</li>
                    <li><strong>Dados de agendamento:</strong> 5 anos após a conclusão</li>
                    <li><strong>Dados de visitas:</strong> 5 anos após a conclusão ou cancelamento</li>
                    <li><strong>Fotos de visitantes:</strong> 1 ano após a visita</li>
                    <li><strong>Logs de acesso:</strong> 1 ano após o registro</li>
                    <li><strong>Dados de solicitação de acesso:</strong> 2 anos após aprovação/rejeição</li>
                    <li><strong>Senhas temporárias:</strong> 30 minutos após geração</li>
                    <li><strong>Tokens de sessão e refresh:</strong> 7 dias após último uso</li>
                    <li><strong>CAPTCHAs:</strong> 10 minutos após geração</li>
                  </ul>
                </div>

                <p>
                  Após o período de retenção, os dados serão eliminados de forma segura ou anonimizados, exceto quando houver obrigação legal de retenção.
                </p>
              </div>
            </section>

            {/* Direitos do Titular */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Direitos do Titular</h2>
              <div className="prose prose-blue max-w-none text-gray-700 space-y-3">
                <p>Conforme a LGPD, você possui os seguintes direitos:</p>
                
                <div className="bg-green-50 p-4 rounded-lg space-y-2">
                  <ul className="list-disc list-inside space-y-1">
                    <li><strong>Confirmação e Acesso:</strong> Solicitar confirmação de que seus dados são tratados e acessá-los</li>
                    <li><strong>Correção:</strong> Solicitar correção de dados incompletos, inexatos ou desatualizados</li>
                    <li><strong>Eliminação:</strong> Solicitar a exclusão de seus dados pessoais</li>
                    <li><strong>Portabilidade:</strong> Solicitar a transferência de seus dados a outro fornecedor</li>
                    <li><strong>Revogação de Consentimento:</strong> Revogar o consentimento a qualquer momento</li>
                    <li><strong>Oposição:</strong> Opor-se ao tratamento de seus dados</li>
                    <li><strong>Informação:</strong> Ser informado sobre compartilhamento de seus dados</li>
                  </ul>
                </div>

                <p>
                  Para exercer seus direitos, entre em contato através do e-mail: <a href="mailto:dpo@grupoaleplast.com.br" className="text-blue-600 hover:underline">dpo@grupoaleplast.com.br</a>
                </p>
              </div>
            </section>

            {/* Segurança */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Segurança dos Dados</h2>
              <div className="prose prose-blue max-w-none text-gray-700 space-y-3">
                <p>Adotamos medidas técnicas e organizacionais adequadas para proteger seus dados pessoais:</p>
                
                <div className="bg-gray-50 p-4 rounded-lg">
                  <ul className="list-disc list-inside space-y-1">
                    <li>Criptografia de senhas (bcrypt com salt)</li>
                    <li>Tokens de acesso JWT com expiração de 15 minutos</li>
                    <li>Refresh tokens revogáveis com expiração de 7 dias</li>
                    <li>Rate limiting para prevenir ataques de força bruta</li>
                    <li>Proteção CSRF (verificação de Origin/Referer)</li>
                    <li>CORS restrito a origens autorizadas</li>
                    <li>Bloqueio de conta após 5 tentativas falhas (15 min) e 10 tentativas (permanente)</li>
                    <li>CAPTCHA após 3 tentativas de login falhas</li>
                    <li>Geração de códigos seguros com crypto.randomBytes</li>
                    <li>Sanitização de entrada para prevenir injection</li>
                    <li>Headers de segurança (Helmet)</li>
                    <li>Logs de acesso e atividades</li>
                    <li>Conexões seguras (HTTPS/TLS)</li>
                  </ul>
                </div>

                <p className="text-sm text-gray-600">
                  Apesar de todos os esforços, nenhum sistema é 100% seguro. Recomendamos que você mantenha sua senha em sigilo e não compartilhe suas credenciais.
                </p>
              </div>
            </section>

            {/* Encarregado */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Encarregado (DPO)</h2>
              <div className="prose prose-blue max-w-none text-gray-700 space-y-3">
                <p>Designamos um Encarregado de Proteção de Dados (DPO) para atuar como canal de comunicação entre o Sistema, os titulares dos dados e a Autoridade Nacional de Proteção de Dados (ANPD).</p>
                
                <div className="bg-blue-50 p-4 rounded-lg">
                  <p><strong>Contato do DPO:</strong></p>
                  <p>E-mail: <a href="mailto:aux.logistica@grupoaleplast.com.br" className="text-blue-600 hover:underline">aux.logistica@grupoaleplast.com.br</a></p>
                </div>
              </div>
            </section>

            {/* Alterações */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Alterações desta Política</h2>
              <div className="prose prose-blue max-w-none text-gray-700 space-y-3">
                <p>
                  Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você sobre alterações significativas através de e-mail ou aviso no sistema.
                </p>
                <p>
                  A data da última atualização será sempre indicada no topo desta página.
                </p>
              </div>
            </section>

            {/* Contato */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Contato</h2>
              <div className="prose prose-blue max-w-none text-gray-700 space-y-3">
                <p>
                  Para dúvidas, reclamações ou solicitações relacionadas à privacidade de dados, entre em contato:
                </p>
                
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p><strong>E-mail:</strong> <a href="mailto:aux.logistica@grupoaleplast.com.br" className="text-blue-600 hover:underline">aux.logistica@grupoaleplast.com.br</a></p>
                  <p><strong>Telefone:</strong> (82) 99119-7455</p>
                  <p><strong>Endereço:</strong> Maceió, Alagoas, Brasil</p>
                </div>
              </div>
            </section>
          </div>

          {/* Footer */}
          <div className="bg-gray-100 px-6 py-4">
            <p className="text-sm text-gray-600 text-center">
              Esta Política está em conformidade com a Lei Geral de Proteção de Dados (LGPD) - Lei nº 13.709/2018.
            </p>
          </div>
        </div>

        {/* Back Button */}
        <div className="mt-6 text-center">
          <Link to="/" className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Voltar ao Início
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PoliticaPrivacidade;
